import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TokenVaultSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
} from '@workspace/ng-aura';
import { TokenVaultActionDisplayPipe, TokenVaultStatusDisplayPipe } from '@workspace/ng-data-access';
import { TokenVaultColumnKey } from './abstract-token-vaults-data-table.component';
import { TokenVaultsDataTableFilterCoreComponent } from './filter/token-vaults-data-table-filter.component';

@Component({
  selector: 'core-token-vaults-data-table',
  standalone: true,
  templateUrl: './token-vaults-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    TokenVaultActionDisplayPipe,
    TokenVaultStatusDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    TokenVaultsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
  ],
})
export class TokenVaultsDataTableCoreComponent extends BaseDataTableCoreComponent<
  TokenVaultSummaryDto,
  TokenVaultColumnKey
> {}
